<template>
  <div class="admin-dashboard">
    <v-container fluid class="pa-6">
      <v-row class="mt-6">
        <v-col cols="12">
          <v-card elevation="4">
            <v-card-title class="primary white--text py-3">
              <v-icon left>mdi-format-list-bulleted</v-icon>
              รายการผู้ทรงคุณวุฒิทั้งหมด
            </v-card-title>

            <v-card-text class="py-4">
              <v-row>
                <v-col cols="12" md="9">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="ค้นหา (ชื่อ, สถานศึกษา, ตำแหน่ง)"
                    outlined
                    dense
                    clearable
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="3" class="d-flex justify-end">
                  <v-btn color="primary" @click="exportToExcel('filtered')">
                    <v-icon left>mdi-file-excel</v-icon>
                    ส่งออกข้อมูลที่กรอง
                  </v-btn>
                  <v-btn
                    icon
                    color="teal"
                    class="ml-2"
                    @click="refreshData"
                    title="รีเฟรชข้อมูล"
                  >
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>

            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="assistantcommitteequalifieds"
              :search="search"
              item-key="assistantcommitteeQualified_id"
              class="elevation-0"
            >
              <template v-slot:item.assistantcommitteeQualifiedType="{ item }">
                <v-chip
                  :color="
                    item.assistantcommitteeQualifiedType === 'inside'
                      ? 'blue-grey'
                      : 'orange'
                  "
                  small
                  text-color="white"
                >
                  {{
                    item.assistantcommitteeQualifiedType === "inside"
                      ? "ภายใน สอศ."
                      : "ภายนอก"
                  }}
                </v-chip>
              </template>

              <template
                v-slot:item.assistantcommitteeQualifiedCancelStatus="{ item }"
              >
                <v-chip
                  small
                  label
                  :color="
                    getApprovalStatusColor(
                      item.assistantcommitteeQualifiedCancelStatus
                    )
                  "
                  text-color="white"
                >
                  <v-icon left small>{{
                    getApprovalStatusIcon(
                      item.assistantcommitteeQualifiedCancelStatus
                    )
                  }}</v-icon>
                  {{
                    getApprovalStatusText(
                      item.assistantcommitteeQualifiedCancelStatus
                    )
                  }}
                </v-chip>
              </template>

              <template v-slot:item.assistantcommitteeQualifiedFile="{ item }">
                <v-btn
                  icon
                  small
                  color="purple"
                  @click="viewPdfFile(item.assistantcommitteeQualifiedFile)"
                  v-if="item.assistantcommitteeQualifiedFile"
                  title="ดูเอกสาร"
                >
                  <v-icon small>mdi-file-pdf-box</v-icon>
                </v-btn>
                <span v-else class="grey--text">-</span>
              </template>

              <template v-slot:item.fullName="{ item }">
                <a
                  href="javascript:void(0)"
                  @click="showDetail(item)"
                  class="primary--text font-weight-medium"
                >
                  {{ item.fullName }}
                </a>
              </template>

              <template v-slot:no-data>
                <v-empty-state
                  icon="mdi-database-search-outline"
                  label="ไม่พบข้อมูล"
                  description="ลองค้นหาด้วยคำแตกต่างไป"
                ></v-empty-state>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Detail Dialog -->
    <v-dialog v-model="detailDialog" max-width="700px">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-account-details</v-icon>
          รายละเอียดผู้ทรงคุณวุฒิ
          <v-spacer></v-spacer>
          <v-btn icon dark @click="detailDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-6" v-if="selectedDetail">
          <v-row>
            <v-col cols="12" md="6">
              <div class="detail-section">
                <h4 class="text-subtitle-2 grey--text mb-2">ข้อมูลส่วนตัว</h4>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-icon
                      ><v-icon small
                        >mdi-card-account-details</v-icon
                      ></v-list-item-icon
                    >
                    <v-list-item-content>
                      <v-list-item-subtitle
                        >รหัสบัตรประชาชน</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-medium">{{
                        selectedDetail.assistantcommitteeQualifiedIDcard
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon
                      ><v-icon small>mdi-account</v-icon></v-list-item-icon
                    >
                    <v-list-item-content>
                      <v-list-item-subtitle>ชื่อ-นามสกุล</v-list-item-subtitle>
                      <v-list-item-title class="font-weight-medium">
                        {{ selectedDetail.fullName }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon
                      ><v-icon small>mdi-briefcase</v-icon></v-list-item-icon
                    >
                    <v-list-item-content>
                      <v-list-item-subtitle>ตำแหน่ง</v-list-item-subtitle>
                      <v-list-item-title class="font-weight-medium">{{
                        selectedDetail.assistantcommitteeQualifiedPosition ||
                          "-"
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon
                      ><v-icon small>mdi-numeric</v-icon></v-list-item-icon
                    >
                    <v-list-item-content>
                      <v-list-item-subtitle>อันดับ</v-list-item-subtitle>
                      <v-list-item-title class="font-weight-medium">
                        <v-chip
                          :color="
                            getRankColor(
                              selectedDetail.assistantcommitteeQualifiedRank
                            )
                          "
                          small
                          dark
                          label
                        >
                          {{
                            selectedDetail.assistantcommitteeQualifiedRank ||
                              "-"
                          }}
                        </v-chip>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="detail-section">
                <h4 class="text-subtitle-2 grey--text mb-2">ข้อมูลการศึกษา</h4>
                <v-list dense>
                  <v-list-item
                    v-if="selectedDetail.assistantcommitteeQualifiedEDDoctoral"
                  >
                    <v-list-item-icon
                      ><v-icon small>mdi-school</v-icon></v-list-item-icon
                    >
                    <v-list-item-content>
                      <v-list-item-subtitle>ปริญญาเอก</v-list-item-subtitle>
                      <v-list-item-title class="font-weight-medium">
                        {{
                          selectedDetail.assistantcommitteeQualifiedEDDoctoralSub
                        }}
                        {{
                          selectedDetail.assistantcommitteeQualifiedEDDoctoral
                        }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    v-if="selectedDetail.assistantcommitteeQualifiedEDMaster"
                  >
                    <v-list-item-icon
                      ><v-icon small>mdi-school</v-icon></v-list-item-icon
                    >
                    <v-list-item-content>
                      <v-list-item-subtitle>ปริญญาโท</v-list-item-subtitle>
                      <v-list-item-title class="font-weight-medium">
                        {{
                          selectedDetail.assistantcommitteeQualifiedEDMasterSub
                        }}
                        {{ selectedDetail.assistantcommitteeQualifiedEDMaster }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    v-if="selectedDetail.assistantcommitteeQualifiedED"
                  >
                    <v-list-item-icon
                      ><v-icon small>mdi-school</v-icon></v-list-item-icon
                    >
                    <v-list-item-content>
                      <v-list-item-subtitle>ปริญญาตรี</v-list-item-subtitle>
                      <v-list-item-title class="font-weight-medium">
                        {{ selectedDetail.assistantcommitteeQualifiedEDSub }}
                        {{ selectedDetail.assistantcommitteeQualifiedED }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-col>
            <v-col cols="12">
              <div class="detail-section">
                <h4 class="text-subtitle-2 grey--text mb-2">ข้อมูลสถานศึกษา</h4>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-icon
                      ><v-icon small>mdi-domain</v-icon></v-list-item-icon
                    >
                    <v-list-item-content>
                      <v-list-item-subtitle>สถานศึกษา</v-list-item-subtitle>
                      <v-list-item-title class="font-weight-medium">{{
                        selectedDetail.college_name
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon
                      ><v-icon small
                        >mdi-check-decagram</v-icon
                      ></v-list-item-icon
                    >
                    <v-list-item-content>
                      <v-list-item-subtitle>สถานะปัจจุบัน</v-list-item-subtitle>
                      <v-list-item-title>
                        <v-chip
                          :color="
                            getApprovalStatusColor(
                              selectedDetail.assistantcommitteeQualifiedCancelStatus
                            )
                          "
                          small
                          dark
                          label
                        >
                          {{
                            getApprovalStatusText(
                              selectedDetail.assistantcommitteeQualifiedCancelStatus
                            )
                          }}
                        </v-chip>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- PDF Viewer Dialog -->
    <v-dialog
      v-model="pdfDialog"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="pdfDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>เอกสารยืนยันตัวตน</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              icon
              dark
              :href="'/HRCommitteeQf/' + pdfFile"
              target="_blank"
              title="เปิดในแท็บใหม่"
            >
              <v-icon>mdi-open-in-new</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pa-0 fill-height">
          <object
            :data="'/HRCommitteeQf/' + pdfFile"
            type="application/pdf"
            width="100%"
            height="calc(100vh - 64px)"
            style="min-height: 500px;"
          >
            <p>
              ไม่สามารถแสดงไฟล์ PDF ได้ กรุณา
              <a :href="'/HRCommitteeQf/' + pdfFile" target="_blank"
                >ดาวน์โหลดไฟล์</a
              >
              แทน
            </p>
          </object>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar Notification -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      top
      right
    >
      <v-icon left>{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import * as XLSX from "xlsx";

export default {
  name: "AdminAssistantCommitteeQualified",
  data() {
    return {
      ApiKey: "HRvec2021",
      loading: true,
      search: "",
      // Data
      assistantcommitteequalifieds: [],
      periodTeachersAssisstant: {},
      colleges: [],
      assistantcommitteequalified_proposals: [],
      // Statistics
      statistics: {
        totalColleges: 0,
        reportedColleges: 0,
        pendingApproval: 0,
        totalQualified: 0,
        insideCount: 0,
        outsideCount: 0
      },

      // Dialogs
      detailDialog: false,
      pdfDialog: false,
      selectedDetail: null,
      pdfFile: "",

      // Snackbar
      snackbar: {
        show: false,
        color: "",
        timeout: 4000,
        icon: "",
        text: ""
      },

      // Table Headers
      headers: [
        {
          text: "ประเภท",
          value: "assistantcommitteeQualifiedType",
          align: "center",
          width: "130"
        },
        { text: "สถานศึกษา", value: "college_name", width: "250" },
        {
          text: "ชื่อ-นามสกุล",
          value: "fullName",
          width: "200"
        },
        {
          text: "ตำแหน่ง",
          value: "assistantcommitteeQualifiedPosition",
          width: "180"
        },
        {
          text: "อันดับ",
          value: "assistantcommitteeQualifiedRank",
          align: "center",
          width: "100"
        },
        {
          text: "สถานะ",
          value: "assistantcommitteeQualifiedCancelStatus",
          align: "center",
          width: "120"
        },
        {
          text: "File",
          value: "assistantcommitteeQualifiedFile",
          align: "center",
          width: "80"
        }
      ]
    };
  },

  computed: {
    reportPercentage() {
      if (this.statistics.totalColleges === 0) return 0;
      return (
        (this.statistics.reportedColleges / this.statistics.totalColleges) *
        100
      ).toFixed(1);
    }
  },

  async mounted() {
    await this.initializeData();
  },

  methods: {
    // --- Data Initialization ---
    async initializeData() {
      this.loading = true;
      try {
        await Promise.all([
          this.periodQueryTeacherAssisstant(),
          this.collegeQueryAll()
        ]);
        await this.assistantcommitteequalifiedsQueryAll();
        await this.assistantcommitteequalified_proposalsQueryAll();

        this.calculateStatistics();
      } catch (error) {
        console.error("Error initializing data:", error);
        this.showSnackbar(
          "error",
          "mdi-alert",
          "เกิดข้อผิดพลาดในการโหลดข้อมูล"
        );
      } finally {
        this.loading = false;
      }
    },

    async refreshData() {
      await this.initializeData();
      this.showSnackbar("success", "mdi-check", "รีเฟรชข้อมูลเรียบร้อย");
    },

    async assistantcommitteequalified_proposalsQueryAll() {
      let result = await this.$http.post(
        "assistantcommitteequalified_proposal.php",
        {
          ApiKey: this.ApiKey,
          action: "get_proposal_admin",
          period_year: this.periodTeachersAssisstant.period_college_year
        }
      );
      this.assistantcommitteequalified_proposals = result.data || [];
    },

    async collegeQueryAll() {
      const result = await this.$http.post("college.php", {
        ApiKey: this.ApiKey
      });
      this.colleges = result.data || [];
    },

    async periodQueryTeacherAssisstant() {
      const result = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_id: "60101"
      });
      this.periodTeachersAssisstant = result.data;
    },

    async assistantcommitteequalifiedsQueryAll() {
      const result = await this.$http.post("assistantcommitteequalified.php", {
        ApiKey: this.ApiKey,
        assistantcommitteeQualifiedAdmin: "ok",
        period_year: this.periodTeachersAssisstant.period_college_year
      });

      // ✅ เพิ่ม fullName field เพื่อให้ search ได้ง่ายขึ้น
      this.assistantcommitteequalifieds = result.data;
    },

    // --- Statistics Logic ---
    calculateStatistics() {
      const data = this.assistantcommitteequalifieds;

      this.statistics.totalQualified = data.length;
      this.statistics.insideCount = data.filter(
        d => d.assistantcommitteeQualifiedType === "inside"
      ).length;
      this.statistics.outsideCount = data.filter(
        d => d.assistantcommitteeQualifiedType === "outside"
      ).length;
      this.statistics.pendingApproval = data.filter(
        d =>
          !d.assistantcommitteeQualifiedCancelStatus ||
          d.assistantcommitteeQualifiedCancelStatus === "pending"
      ).length;

      const reportedCollegeCodes = this.assistantcommitteequalified_proposals
        .filter(
          p =>
            p.assistantcommitteeQualifiedCancelStatus !== "cancel_proposal_file"
        )
        .map(p => p.college_code);

      this.statistics.reportedColleges = new Set(reportedCollegeCodes).size;
      this.statistics.totalColleges = this.colleges.length;
    },

    // --- View Methods ---
    showDetail(item) {
      this.selectedDetail = item;
      this.detailDialog = true;
    },

    viewPdfFile(filename) {
      this.pdfFile = filename;
      this.pdfDialog = true;
    },

    // --- Export Methods ---
    exportToExcel(type) {
      let data = [];
      let filename = "";
      let rawData = [];

      if (type === "filtered") {
        rawData = this.assistantcommitteequalifieds;
        filename = "ผู้ทรงคุณวุฒิ_ตามตัวกรอง";
      } else if (type === "all") {
        rawData = this.assistantcommitteequalifieds;
        filename = "ผู้ทรงคุณวุฒิทั้งหมด";
      }

      // Map data for Excel export
      data = rawData.map(item => ({
        ประเภท:
          item.assistantcommitteeQualifiedType === "outside"
            ? "ภายนอก/เกษียณ"
            : "ภายใน สอศ.",
        รหัสสถานศึกษา: item.assistantcommitteeQualifiedCollege,
        สถานศึกษา: item.college_name,
        รหัสบัตรประชาชน: item.assistantcommitteeQualifiedIDcard,
        คำนำหน้า: item.assistantcommitteeQualifiedTitles,
        ชื่อ: item.assistantcommitteeQualifiedFristname,
        นามสกุล: item.assistantcommitteeQualifiedLastname,
        ตำแหน่ง: item.assistantcommitteeQualifiedPosition,
        ตำแหน่งเพิ่มเติม: item.assistantcommitteeQualifiedETC,
        สังกัด: item.assistantcommitteeQualifiedCollegeMain,
        วุฒิการศึกษา_ตรี: item.assistantcommitteeQualifiedED,
        สาขา_ตรี: item.assistantcommitteeQualifiedEDSub,
        วุฒิการศึกษา_โท: item.assistantcommitteeQualifiedEDMaster,
        สาขา_โท: item.assistantcommitteeQualifiedEDMasterSub,
        วุฒิการศึกษา_เอก: item.assistantcommitteeQualifiedEDDoctoral,
        สาขา_เอก: item.assistantcommitteeQualifiedEDDoctoralSub,
        อันดับ: item.assistantcommitteeQualifiedRank || "-",
        สถานะ: this.getApprovalStatusText(
          item.assistantcommitteeQualifiedCancelStatus
        )
      }));

      if (data.length === 0) {
        this.showSnackbar(
          "warning",
          "mdi-alert-circle",
          "ไม่พบข้อมูลที่ต้องการส่งออก"
        );
        return;
      }

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

      // Auto-width columns
      const colWidths = Object.keys(data[0] || {}).map(key => ({
        wch:
          Math.max(
            key.length,
            ...data.map(row => String(row[key] || "").length)
          ) + 2
      }));
      ws["!cols"] = colWidths;

      XLSX.writeFile(
        wb,
        `${filename}_${this.formatDateForFile(new Date())}.xlsx`
      );
      this.showSnackbar("success", "mdi-file-excel", "ส่งออกข้อมูลเรียบร้อย");
    },

    // --- Helper Methods ---
    getRankColor(rank) {
      const colors = { "1": "amber darken-2", "2": "blue-grey" };
      return colors[rank] || "grey";
    },

    getApprovalStatusColor(status) {
      const colors = {
        approve_proposal: "success",
        rejected: "error",
        pending: "warning"
      };
      return colors[status] || "warning";
    },

    getApprovalStatusIcon(status) {
      const icons = {
        approve_proposal: "mdi-check-circle",
        rejected: "mdi-close-circle",
        pending: "mdi-clock-outline"
      };
      return icons[status] || "mdi-clock-outline";
    },

    getApprovalStatusText(status) {
      const texts = {
        approve_proposal: "อนุมัติแล้ว",
        rejected: "ปฏิเสธ",
        pending: "รออนุมัติ"
      };
      return texts[status] || "รออนุมัติ";
    },

    formatDate(dateStr) {
      if (!dateStr) return "-";
      const date = new Date(
        dateStr.replace(" ", "T") + (dateStr.endsWith("Z") ? "" : "")
      );
      if (isNaN(date.getTime())) {
        return dateStr;
      }
      return date.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric"
      });
    },

    formatDateForFile(date) {
      return date.toISOString().split("T")[0];
    },

    showSnackbar(color, icon, text) {
      this.snackbar = {
        show: true,
        color,
        icon,
        text,
        timeout: 4000
      };
    }
  }
};
</script>

<style scoped>
.admin-dashboard {
  background: #f4f6f9;
  min-height: 100vh;
}

.detail-section {
  background: #f8f9fa;
  border-left: 4px solid #1976d2;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 10px;
}

::v-deep .v-data-table {
  border-radius: 0 0 4px 4px;
}

::v-deep .v-data-table thead th {
  font-weight: 700 !important;
  font-size: 14px !important;
  background: #f0f3f6 !important;
  color: #333 !important;
}

::v-deep .v-data-table tbody tr:hover {
  background: #e3f2fd !important;
}

.fill-height {
  height: 100%;
}
</style>
